import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Languages } from "lucide-react";
import { LANGS, useI18n } from "@/i18n/I18n";
import { api } from "@/lib/api";

export const LanguageSelect = ({ persist = false, className = "" }) => {
  const { lang, setLang } = useI18n();
  const change = (l) => {
    setLang(l);
    if (persist) api.put("/auth/profile", { language: l }).catch(() => {});
  };
  return (
    <Select value={lang} onValueChange={change}>
      <SelectTrigger data-testid="language-select" className={`h-11 gap-2 ${className}`}>
        <Languages className="w-4 h-4 text-slate-500" /><SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LANGS.map((l) => <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>{l.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
